module.exports = __webpack_public_path__ + "img/spose.e97a7fa4.jpg";